export default __webpack_public_path__ + "static/media/user-check.6854459f.svg";